import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {useElementHover} from '@vueuse/core';
import {computed, ref} from 'vue';
import {useStore} from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'GalleryThumbnail',
  props: {
    index: {},
    image: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const elRef = ref<HTMLElement | undefined>();

const isHover = useElementHover(elRef);
const isActive = computed(() => store.currentIndex === props.index);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "elRef",
    ref: elRef,
    class: _normalizeClass(['gallery-thumb', {'is-hover': _unref(isHover), 'is-active': isActive.value}]),
    style: _normalizeStyle({'background-image': `url(${_ctx.image})`}),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).showImage(_ctx.index)))
  }, null, 6 /* CLASS, STYLE */))
}
}

})